import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "main-content-container overflow-hidden" }
const _hoisted_2 = {
  key: 0,
  class: "card bg-white border-0 rounded-3 mb-4"
}
const _hoisted_3 = { class: "card-body p-4" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-lg-4 col-sm-4 col-md-4" }
const _hoisted_6 = { class: "mb-4" }
const _hoisted_7 = { class: "mb-4" }
const _hoisted_8 = { class: "text-secondary" }
const _hoisted_9 = { class: "mb-1 fw-medium text-dark" }
const _hoisted_10 = { class: "mb-1 text-secondary" }
const _hoisted_11 = { class: "mb-1 text-secondary" }
const _hoisted_12 = { class: "col-lg-4 col-sm-4 col-md-4" }
const _hoisted_13 = { class: "mb-4 text-center" }
const _hoisted_14 = { class: "mb-1 text-secondary" }
const _hoisted_15 = { class: "mb-1 text-secondary" }
const _hoisted_16 = { class: "col-lg-4 col-sm-4 col-md-4" }
const _hoisted_17 = { class: "mb-4 text-sm-end" }
const _hoisted_18 = { class: "mb-4" }
const _hoisted_19 = { class: "text-secondary" }
const _hoisted_20 = { class: "mb-1 fw-medium text-dark" }
const _hoisted_21 = { class: "mb-1 text-secondary" }
const _hoisted_22 = { class: "mb-1 text-secondary" }
const _hoisted_23 = { class: "default-table-area all-products" }
const _hoisted_24 = { class: "table-responsive" }
const _hoisted_25 = { class: "table align-middle" }
const _hoisted_26 = { class: "text-secondary fw-medium" }
const _hoisted_27 = { class: "text-body" }
const _hoisted_28 = { class: "text-secondary fw-bold fs-16" }
const _hoisted_29 = { class: "mt-5 border-top pt-4" }
const _hoisted_30 = {
  key: 0,
  class: "row"
}
const _hoisted_31 = { class: "col-lg-6" }
const _hoisted_32 = { class: "list-group list-group-flush mb-4" }
const _hoisted_33 = { class: "list-group-item px-0 pb-2 pt-0 d-flex justify-content-between" }
const _hoisted_34 = { class: "fw-medium text-dark" }
const _hoisted_35 = { class: "list-group-item px-0 py-2 d-flex justify-content-between" }
const _hoisted_36 = { class: "fw-medium text-dark" }
const _hoisted_37 = { class: "list-group-item px-0 py-2 d-flex justify-content-between" }
const _hoisted_38 = {
  key: 0,
  class: "list-group-item px-0 py-2 d-flex justify-content-between"
}
const _hoisted_39 = { class: "fw-medium text-dark" }
const _hoisted_40 = { class: "text-muted" }
const _hoisted_41 = {
  key: 1,
  class: "list-group-item px-0 py-2 d-flex justify-content-between"
}
const _hoisted_42 = { class: "text-danger" }
const _hoisted_43 = {
  key: 0,
  class: "d-flex flex-column gap-3 mt-4"
}
const _hoisted_44 = { class: "mb-2" }
const _hoisted_45 = { class: "d-flex gap-2" }
const _hoisted_46 = ["disabled"]
const _hoisted_47 = ["disabled"]
const _hoisted_48 = { class: "col-lg-6 text-center" }
const _hoisted_49 = ["href"]
const _hoisted_50 = ["src"]
const _hoisted_51 = {
  key: 1,
  class: "text-center"
}
const _hoisted_52 = {
  key: 1,
  class: "alert alert-secondary text-center mt-3 p-4"
}
const _hoisted_53 = {
  key: 1,
  class: "text-center p-5"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageTitle = _resolveComponent("PageTitle")!
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageTitle, {
      pageTitle: "Payment Details & Verification",
      subTitle: "Payments"
    }),
    (!_ctx.loading && _ctx.payment)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("p", _hoisted_7, [
                    _cache[3] || (_cache[3] = _createTextVNode(" Payment ID: ")),
                    _createElementVNode("span", _hoisted_8, "#" + _toDisplayString(_ctx.payment.payment_id), 1)
                  ]),
                  _cache[5] || (_cache[5] = _createElementVNode("p", { class: "mb-1" }, "Customer:", -1)),
                  _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.payment.order?.customer?.name || '-'), 1),
                  _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.payment.order?.customer?.phone_number || '-'), 1),
                  _createElementVNode("p", _hoisted_11, [
                    _cache[4] || (_cache[4] = _createTextVNode(" Status: ")),
                    _createElementVNode("span", {
                      class: _normalizeClass(["badge", _ctx.statusClass(_ctx.payment.payment_status)])
                    }, _toDisplayString(_ctx.payment.payment_status), 3)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _cache[7] || (_cache[7] = _createElementVNode("h4", { class: "fs-16 fw-medium mb-3" }, "Order Info", -1)),
                  _createElementVNode("p", _hoisted_14, [
                    _cache[6] || (_cache[6] = _createTextVNode("Code: ")),
                    _createVNode(_component_RouterLink, {
                      to: `/orders/${_ctx.payment.order_id}`
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.payment.order?.order_code), 1)
                      ]),
                      _: 1
                    }, 8, ["to"])
                  ]),
                  _createElementVNode("p", _hoisted_15, "Service: " + _toDisplayString(_ctx.payment.order?.service_type), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("p", _hoisted_18, [
                    _cache[8] || (_cache[8] = _createTextVNode(" Date: ")),
                    _createElementVNode("span", _hoisted_19, _toDisplayString(new Date(_ctx.payment.created_at).toLocaleDateString()), 1)
                  ]),
                  _cache[9] || (_cache[9] = _createElementVNode("p", { class: "mb-1" }, "Pay To:", -1)),
                  _createElementVNode("p", _hoisted_20, _toDisplayString(_ctx.payment.channel?.provider_name), 1),
                  _createElementVNode("p", _hoisted_21, _toDisplayString(_ctx.payment.channel?.account_number), 1),
                  _createElementVNode("p", _hoisted_22, _toDisplayString(_ctx.payment.channel?.account_name), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("table", _hoisted_25, [
                  _cache[15] || (_cache[15] = _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", { scope: "col" }, "No"),
                      _createElementVNode("th", { scope: "col" }, "Item Description"),
                      _createElementVNode("th", { scope: "col" }, "Quantity"),
                      _createElementVNode("th", { scope: "col" }, "Total")
                    ])
                  ], -1)),
                  _createElementVNode("tbody", null, [
                    _createElementVNode("tr", null, [
                      _cache[10] || (_cache[10] = _createElementVNode("td", { class: "text-body" }, "1", -1)),
                      _createElementVNode("td", _hoisted_26, _toDisplayString(_ctx.payment.order?.service?.service_name || 'Service Order'), 1),
                      _cache[11] || (_cache[11] = _createElementVNode("td", { class: "text-body" }, "1", -1)),
                      _createElementVNode("td", _hoisted_27, "Rp " + _toDisplayString(Number(_ctx.payment.order?.total_price).toLocaleString('id-ID')), 1)
                    ]),
                    _createElementVNode("tr", null, [
                      _cache[12] || (_cache[12] = _createElementVNode("td", null, null, -1)),
                      _cache[13] || (_cache[13] = _createElementVNode("td", null, null, -1)),
                      _cache[14] || (_cache[14] = _createElementVNode("td", { class: "fw-medium text-secondary" }, "Grand Total", -1)),
                      _createElementVNode("td", _hoisted_28, "Rp " + _toDisplayString(Number(_ctx.payment.order?.total_price).toLocaleString('id-ID')), 1)
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_29, [
              _cache[26] || (_cache[26] = _createElementVNode("h4", { class: "mb-3" }, "Payment Proof", -1)),
              (_ctx.payment.proof)
                ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                    _createElementVNode("div", _hoisted_31, [
                      _createElementVNode("ul", _hoisted_32, [
                        _createElementVNode("li", _hoisted_33, [
                          _cache[16] || (_cache[16] = _createElementVNode("span", { class: "text-secondary" }, "Sender Name", -1)),
                          _createElementVNode("span", _hoisted_34, _toDisplayString(_ctx.payment.proof.sender_name || '-'), 1)
                        ]),
                        _createElementVNode("li", _hoisted_35, [
                          _cache[17] || (_cache[17] = _createElementVNode("span", { class: "text-secondary" }, "Sender Bank", -1)),
                          _createElementVNode("span", _hoisted_36, _toDisplayString(_ctx.payment.proof.sender_bank || '-'), 1)
                        ]),
                        _createElementVNode("li", _hoisted_37, [
                          _cache[18] || (_cache[18] = _createElementVNode("span", { class: "text-secondary" }, "Verification Status", -1)),
                          _createElementVNode("span", {
                            class: _normalizeClass(["badge", _ctx.proofStatusClass(_ctx.payment.proof.verification_status)])
                          }, _toDisplayString(_ctx.payment.proof.verification_status), 3)
                        ]),
                        (_ctx.payment.proof.verified_by)
                          ? (_openBlock(), _createElementBlock("li", _hoisted_38, [
                              _cache[19] || (_cache[19] = _createElementVNode("span", { class: "text-secondary" }, "Verified By", -1)),
                              _createElementVNode("span", _hoisted_39, [
                                _createTextVNode(_toDisplayString(_ctx.payment.proof.verified_by.name) + " ", 1),
                                _createElementVNode("small", _hoisted_40, "(" + _toDisplayString(_ctx.payment.proof.verified_by.email) + ")", 1)
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.payment.proof.rejection_reason)
                          ? (_openBlock(), _createElementBlock("li", _hoisted_41, [
                              _cache[20] || (_cache[20] = _createElementVNode("span", { class: "text-secondary" }, "Rejection Reason", -1)),
                              _createElementVNode("span", _hoisted_42, _toDisplayString(_ctx.payment.proof.rejection_reason), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      (_ctx.payment.payment_status !== 'Paid' && _ctx.payment.proof?.verification_status !== 'Verified')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                            _cache[24] || (_cache[24] = _createElementVNode("h6", { class: "mb-1" }, "Verification Action", -1)),
                            _createElementVNode("div", _hoisted_44, [
                              _cache[21] || (_cache[21] = _createElementVNode("label", { class: "form-label" }, "Rejection Reason (Optional, only if rejecting)", -1)),
                              _withDirectives(_createElementVNode("textarea", {
                                class: "form-control",
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.rejectionReason) = $event)),
                                rows: "2"
                              }, null, 512), [
                                [_vModelText, _ctx.rejectionReason]
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_45, [
                              _createElementVNode("button", {
                                class: "btn btn-danger py-2 px-4 fw-medium flex-grow-1 text-white",
                                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.verifyPayment('Rejected'))),
                                disabled: !_ctx.payment.proof
                              }, _cache[22] || (_cache[22] = [
                                _createElementVNode("i", { class: "ri-close-circle-line me-1" }, null, -1),
                                _createTextVNode(" Reject ")
                              ]), 8, _hoisted_46),
                              _createElementVNode("button", {
                                class: "btn btn-success py-2 px-4 fw-medium flex-grow-1 text-white",
                                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.verifyPayment('Verified'))),
                                disabled: !_ctx.payment.proof
                              }, _cache[23] || (_cache[23] = [
                                _createElementVNode("i", { class: "ri-check-line me-1" }, null, -1),
                                _createTextVNode(" Confirm Payment ")
                              ]), 8, _hoisted_47)
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_48, [
                      _createElementVNode("a", {
                        href: _ctx.getFileUrl(_ctx.payment.proof.proof_file),
                        target: "_blank",
                        class: "d-block bg-light p-3 rounded h-100 d-flex align-items-center justify-content-center"
                      }, [
                        (_ctx.isImage(_ctx.payment.proof.proof_file))
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: _ctx.getFileUrl(_ctx.payment.proof.proof_file),
                              class: "img-fluid rounded shadow-sm",
                              style: {"max-height":"400px","object-fit":"contain"},
                              alt: "Payment Proof"
                            }, null, 8, _hoisted_50))
                          : (_openBlock(), _createElementBlock("div", _hoisted_51, _cache[25] || (_cache[25] = [
                              _createElementVNode("i", {
                                class: "ri-file-text-line text-secondary mb-2 d-block",
                                style: {"font-size":"4rem"}
                              }, null, -1),
                              _createElementVNode("span", { class: "fs-16 fw-medium" }, "View Document Proof", -1)
                            ])))
                      ], 8, _hoisted_49)
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_52, " Customer has not uploaded any payment proof yet. "))
            ])
          ])
        ]))
      : (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_53, _cache[27] || (_cache[27] = [
            _createElementVNode("div", {
              class: "spinner-border text-primary",
              role: "status"
            }, [
              _createElementVNode("span", { class: "visually-hidden" }, "Loading...")
            ], -1)
          ])))
        : _createCommentVNode("", true)
  ]))
}